import { useRef } from 'react';
import AccordionFAQStyled from './AccordionFAQStyled';
import { v4 as uuidv4 } from 'uuid';
import { trackEvent } from '~/helpers/tracking';
import useIsInViewport from '~/hooks/useInViewport';
import PhoneNumber from '../PhoneNumber';
import { AccordionItem } from './AccordionItem';
import { useSelector } from 'react-redux';
import { ReduxState } from '~/types/redux';

interface Props {
  children?: unknown;
  enabled: string;
  title?: {
    copy: string;
  };
  subtitle?: {
    copy: string;
    enabled: string;
  };
}

const accordionData = (callInNumber) => [
  {
    title: 'I have some questions. Can I call in to order?',
    content: (
      <>
        Call <PhoneNumber number={callInNumber} className="faq__phone" showIcon={false} /> to check out with help from
        one of our experts. We're happy to walk you through it.
      </>
    ),
  },
  {
    title: 'How quickly can I get Wi-Fi set up in my home?',
    content: 'We’ll get you up and running as soon as tomorrow. You can schedule your installation at checkout.',
  },
  {
    title: 'Is equipment included?',
    content:
      'All fiber plans come with different routers that best support each speed. It’s all a part of the package! If you want to add extenders or other additional equipment, you can do so in our online cart or over the phone.',
  },
  {
    title: 'What is fiber, anyway?',
    content:
      'Fiber-optic technology delivers ultrafast upload and download speeds with 99.9% network reliablity. That wasn’t possible in the past. So instead of waiting for your internet to catch up, you can game, stream, work, and more on multiple devices at once—confidently. ',
  },
];

const AccordionFAQ: React.FC<Props> = ({ title, subtitle }) => {
  const faqRef = useRef();
  const { callInNumber } = useSelector((store: ReduxState) => store);

  const inViewport = useIsInViewport(faqRef);

  if (inViewport) {
    trackEvent({
      action: 'elementViewed',
      data: {
        elementType: 'FAQs',
        location: 'product_selection_page',
        position: 'footer',
        text: 'product_faqs',
      },
    });
  }

  return (
    <AccordionFAQStyled>
      <div className="faq" ref={faqRef}>
        <div className="faq-header-wrapper">
          <h2 className="faq__headline">{title?.copy || 'Frequently Asked Questions'}</h2>
          {subtitle?.enabled !== 'false' && <h3 className="faq__subhead">{(subtitle?.copy || `Questions about Frontier? We've got answers.`)}</h3>}
        </div>
        <div className="faq__questions-wrapper">
          {(accordionData(callInNumber)).map((data, index) =>{
            if (data?.title && data?.content) {
              return  (
                <AccordionItem key={uuidv4()} id={index} title={data?.title}>
                  {data?.content}
                </AccordionItem>
              )
            }
            return null;
          })}
        </div>
      </div>
    </AccordionFAQStyled>
  );
};

AccordionFAQ.displayName = 'AccordionFAQ';

export default AccordionFAQ;
